import { AddStayForm } from '@/components/dashboard/AddStayForm';

export default function HostAddStay() {
  return <AddStayForm />;
}
